import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
// import index from '@/components/index'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'login',
      component: () =>
        import(
          /* webpackChunkName: "index" */ "../components/login.vue"
          ),
    },
    {
      path: '/index',
      name: 'index',
      component: () =>
        import(
          /* webpackChunkName: "index" */ "../components/index/index.vue"
          ),
    },
    {
      path: "/regist",
      component: () =>
        import(
          /* webpackChunkName: "index" */ "../components/regist.vue"
        ),
    },
    {
      path: "/index",
      component: () =>
        import(
          /* webpackChunkName: "index" */ "../components/index/index.vue"
        ),
    },
    {
      path: "/productDetails",
      component: () =>
        import(
          /* webpackChunkName: "productDetails" */ "../components/productDetails/productDetails.vue"
        ),
    },
    {
      path: "/personalCenter",
      component: () =>
        import(
          /* webpackChunkName: "personalCenter" */ "../components/personalCenter/personalCenter.vue"
        ),
    },
    {
      path: "/myWallet",
      component: () =>
        import(
          /* webpackChunkName: "myWallet" */ "../components/myWallet/myWallet.vue"
        ),
    },
    {
      path: "/myOrder",
      component: () =>
        import(
          /* webpackChunkName: "myOrder" */ "../components/myOrder/myOrder.vue"
        ),
    },
    {
      path: "/Members",
      component: () =>
        import(
          "../components/myMembers/index.vue"
        ),
    },
    {
      path: "/Template",
      component: () =>
        import(
          "../components/myTemplate/myTemplate.vue"
        ),
    },
    {
      path: "/notice",
      component: () =>
        import(
          "../components/notice/index.vue"
        ),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js